import React, { FC } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Layout from '../components/Layout';
import SEO from '../components/Seo';
import { Routes } from '../constants/Routes';
import Title from '../components/title';
import { IFluidObject } from 'gatsby-background-image';
import Lightbox from '../components/Lightbox';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
const NEWS_QUERY = graphql`
  {
    allContentfulNews(limit: 8) {
      nodes {
        titel
        date
        bilder {
          fluid {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        body {
          json
        }
      }
    }
  }
`;

type News = {
  id: string;
  titel: string;
  date: Date;
  json: any;
  bilder: IFluidObject[];
};

const NewsPage: FC = () => {
  const data = useStaticQuery(NEWS_QUERY);
  const newsRaw: News[] =
    data.allContentfulNews &&
    data.allContentfulNews.nodes.map((node: any) => ({
      id: node.id,
      titel: node.titel || null,
      date: new Date(node.date),
      json: (node.body && node.body.json) || null,
      bilder: node.bilder ? node.bilder.map((b: any) => b.fluid) : [],
    }));
  // makes sure there is alwayas a valid entry in the news section
  const news = newsRaw.filter(news => news.titel !== 'DUMMY_NEWS');

  // @ts-ignore
  news.sort((a, b) => b.date - a.date);
  return (
    <Layout location={Routes.NEWS}>
      <SEO title="News" />
      <div className="mt-8">
        <Title className="mb-4 text-center">News</Title>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto px-4 items-start">
          {news &&
            news.map(n => (
              <div key={n.id} className="transition-all transition-250 hover:shadow-xl rounded overflow-hidden shadow-lg">
                <div className="">
                  {n.bilder && n.bilder.length > 0 && (
                    <Lightbox
                      className="w-full max-w-md"
                      galleryButtonVisible={false}
                      autoPlaying={false}
                      youtubeUrls={[]}
                      images={n.bilder}
                    />
                  )}
                  <div className="w-full p-4">
                    <div className="px-6 py-4">
                      {n.titel && <div className="font-bold text-xl mb-2">{n.titel}</div>}
                      {n.json && <div className="markdown-body">{documentToReactComponents(n.json)}</div>}
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </Layout>
  );
};

export default NewsPage;
